import { getBlogCategories } from '@app/services/blog';

const displayAllCategories = (article) => {
	let categoryName = [];
	article.content.categories.forEach((category) => {
		categoryName = [...categoryName, category?.name];
	});
	return categoryName.join(' / ');
};
const generateCategoriesLinks = async (componentsType, pathname, fetch) => {
	let categoriesLinks = [];
	const categories = await getBlogCategories(fetch);
	categories?.stories.forEach((category) => {
		categoriesLinks = [
			...categoriesLinks,
			{
				component: componentsType,
				props: {
					props: {
						label: category.name,
						href: `/blog/categories/${category.slug}`,
						classNames: pathname === `/categories/${category.slug}` ? 'selected' : ''
					}
				}
			}
		];
	});
	return categoriesLinks;
};
const getCategoriesArticle = (article) => {
	let uuidCategories = [];
	article.content.categories.forEach((element) => {
		uuidCategories = [...uuidCategories, element.uuid];
	});
	return uuidCategories;
};

export { displayAllCategories, generateCategoriesLinks, getCategoriesArticle };
